export const demoDomain = "demo.rezonence.com";
